export { default } from "./src/extension/index.ts";
